/**
 * 保证金列表页面
 */
export const UNFREEZE_APPLY_LIST_PAGE_UUID =
  'b852612e-3b89-407a-9699-cd9f7578c33b'
